import { Outlet } from "react-router-dom";
import { Toaster } from "sonner";

import logo from "@/assets/logo/promptlayer-long-light.png";
import noiseBackground from "@/assets/noise-background.png";
import { TOASTER_CONFIG } from "@/utils/toaster-config";

export default function LoginLayout() {
  return (
    <div className="relative flex h-full flex-col overflow-hidden bg-gradient-to-br from-[#1439A0] to-[#B1C6FF]">
      <img
        src={noiseBackground}
        alt="noise"
        className="absolute left-0 top-0 h-full w-full object-cover opacity-[40%]"
      />
      <div className="absolute z-[51] p-8 phone:p-6">
        <a href="/">
          <img src={logo} alt="PromptLayer" className="h-8 w-auto" />
        </a>
      </div>
      <main className="z-50 flex w-full flex-1 items-center justify-center px-4">
        <div className="flex h-fit w-full max-w-[424px] flex-col gap-2 rounded-[30px] border border-gray-200 bg-white p-8 shadow-2xl phone:p-4">
          <Outlet />
        </div>
        <Toaster {...TOASTER_CONFIG} />
      </main>
    </div>
  );
}
